module.exports = __webpack_public_path__ + "img/18.44244768.jpg";